// extracted by mini-css-extract-plugin
export default {"tick_container":"TickCross_tick_container__IWBaf"};